const setupLanguageSelector = () => {
    let currentLanguage = "";
    switch (get_cookie('pref_language')) {
        case "de":
            currentLanguage = "Deutsch";
            break;
        case "en":
            currentLanguage = "English";
            break;
        case "fr":
            currentLanguage = "Français";
            break;
        case "nl":
            currentLanguage = "Nederlands";
            break;
        default:
            currentLanguage = "English";
    }
    $('#language-selector-btn').text(currentLanguage);
    $('#language-selector-dropdown').val(get_cookie('pref_language'));
};

const getLanguageSelectorData = function () {
    return new Promise(function (resolve, reject) {
      $.ajax({
        url: '/api/locale/selector',
        type: 'GET',
        data: {
          csrf_token: page_info.csrf_token
        },
        success: function (data) {
            if (!!data.show_language_selector) {
                $('#language-selector-btn-container').removeClass('tw-hidden');
                $('#language-selector-dropdown').empty();
                data.languages.forEach(element => {
                    const option = document.createElement('option');
                    option.setAttribute('notranslate', '');
                    option.value = element.language;
                    option.innerHTML = element.language_readable;
                    $('#language-selector-dropdown').append(option);
                });
            }
            resolve();
        },
        error: function () {
            logger.error('Error getting language selector data');
            reject();
        },
        });
    });
};

$(document).ready(async () => {
    try {
        await getLanguageSelectorData();
        setupLanguageSelector();
    } catch (error) {
        logger.error('Error setting up language selector:', error);
    }

    $('#language-selector-btn').on('click', () => {
        $('#language-selector').modal('show');
        LanguageSelectorEvent('language_icon_clicked').send();
    });

    $('#language-selector-save').on('click', () => {
        const selectedLanguage = $('#language-selector-dropdown').val();
        if (selectedLanguage !== get_cookie('pref_language')) {
            const currentDomain = window.location.hostname.replace(/^www/, '');
            const additional_param_info = ';domain=' + currentDomain;

            const expiryValue = (3600 * 24 * 30);

            set_cookie('pref_language', selectedLanguage, expiryValue, additional_param_info);
            location.reload();
        }
        LanguageSelectorEvent('language_popup_option_selected', 'language_selection', selectedLanguage).send();
    });
});
